export const money = (v, digits = 2) => {
  const n = Number(v || 0);
  const abs = Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
  return `${n < 0 ? "−" : ""}$${abs}`;
};
export const num = (v, digits = 0) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: digits });
export const meters = (v) => `${num(v, 2)} م`;
export const dateAr = (iso) => (iso ? new Date(iso).toLocaleDateString("ar-SY", { year: "numeric", month: "short", day: "numeric" }) : "—");
// Today's calendar date (YYYY-MM-DD) in Asia/Damascus — matches the backend accounting calendar, independent of device/UTC.
export const damascusToday = (now = new Date()) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Damascus", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
export const pct = (cur, prev) => {
  if (!prev) return null;
  return Math.round(((Number(cur || 0) - Number(prev)) / Number(prev)) * 100);
};
